export const SITE_URL = (import.meta.env.VITE_SITE_URL || "http://localhost:3000").replace(/\/$/, "");
export const SITE_NAME = "Book Swap";

type HeadOpts = {
  path: string;
  title: string;
  description: string;
  type?: string;
  /** Private / account-only pages: keep them out of search results. */
  noindex?: boolean;
  /** Optional JSON-LD blocks built with jsonLd(). */
  scripts?: Array<{ type: string; children: string }>;
};

/**
 * Builds a consistent, self-referencing head block for a route:
 * unique title/description, og:title/og:description/og:url and canonical.
 */
export function pageHead({ path, title, description, type = "website", noindex = false, scripts = [] }: HeadOpts) {
  const url = `${SITE_URL}${path}`;
  const meta: Array<Record<string, string>> = [
    { title },
    { name: "description", content: description },
    { property: "og:title", content: title },
    { property: "og:description", content: description },
    { property: "og:url", content: url },
    { property: "og:type", content: type },
    { property: "og:site_name", content: SITE_NAME },
    { name: "twitter:card", content: "summary_large_image" },
    { name: "twitter:title", content: title },
    { name: "twitter:description", content: description },
  ];
  if (noindex) meta.push({ name: "robots", content: "noindex, nofollow" });
  return {
    meta,
    links: noindex ? [] : [{ rel: "canonical", href: url }],
    scripts,
  };
}


export function jsonLd(data: Record<string, unknown>) {
  return { type: "application/ld+json", children: JSON.stringify(data) };
}
